import React from "react";
import { useSelector } from "react-redux";
import { Button, Popover } from "@bca/ui-library";

import PopoverContent from "./PopoverContent";
import PrintSVG from "./PrintSVG";
import { PrintProps } from "./PrintProps.type";
import { StoreType } from "../StoreType";
import { GET_STATE } from "../redux/slices/appSlice";

const PopoverMobile: React.FunctionComponent<PrintProps> = ({
  printUrls,
  vehicleAnalytics,
  pdfEnabled,
}) => {
  const {
    app: { isPrintServiceUnavailable },
  }: StoreType = useSelector(GET_STATE);

  const button = (
    <Button
      variant="secondary-white"
      padding="10px"
      height="auto"
      css={`
        &[aria-expanded="true"] {
          background-color: white;
          path {
            fill: black;
          }
        }
      `}
    >
      <PrintSVG width="21px" height="21px" fill="white" />
    </Button>
  );

  return (
    <>
      {isPrintServiceUnavailable ? (
        button
      ) : (
        <Popover
          width="260px"
          paddingX={6}
          paddingY={6}
          placement="bottom left"
          offsetY={2}
          offsetX={0}
        >
          {button}
          <PopoverContent
            printUrls={printUrls}
            vehicleAnalytics={vehicleAnalytics}
            pdfEnabled={pdfEnabled}
          />
        </Popover>
      )}
    </>
  );
};

export default PopoverMobile;
